import R from "ramda";

import { isPast, isFuture } from "date-fns";

import Embed from "./Embed";

export default Embed;

export const isActiveArticle = (article, includeUnpublished = false) =>
  R.where(
    {
      publicationDate: R.anyPass([R.isNil, isPast]),
      unpublishDate: R.anyPass([
        R.isNil,
        isFuture,
        R.always(includeUnpublished),
      ]),
    },
    article
  );



// WEBPACK FOOTER //
// ./src/components/Embed/index.js